export default {
  state: {
    blePasses: [],
    blePassesMeta: {},
    bleIssuers: [],
  },
  getters: {
    blePasses: state => state.blePasses,
    blePassesMeta: state => state.blePassesMeta,
    bleIssuers: state => state.bleIssuers,
  },
  mutations: {
    SET_BLE_PASSES(state, payload) {
      state.blePasses = payload
    },
    SET_BLE_PASSES_META(state, payload) {
      state.blePassesMeta = payload
    },
    SET_BLE_ISSUERS(state, payload) {
      state.bleIssuers = payload
    },
  },
  actions: {
    setBlePasses({ commit }, payload) {
      commit('SET_BLE_PASSES', payload)
    },
    setBlePassesMeta({ commit }, payload) {
      commit('SET_BLE_PASSES_META', payload)
    },
    setBleIssuers({ commit }, payload) {
      commit('SET_BLE_ISSUERS', payload)
    },
  },
}
